"use strict";
var PaymentInformation = (function () {
    function PaymentInformation() {
    }
    return PaymentInformation;
}());
exports.PaymentInformation = PaymentInformation;
var ApiPolicyEditResponse = (function () {
    function ApiPolicyEditResponse() {
    }
    return ApiPolicyEditResponse;
}());
exports.ApiPolicyEditResponse = ApiPolicyEditResponse;
//# sourceMappingURL=D:/a/1/s/edit/src/models/edit-policy-response.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/src/models/edit-policy-response.model.js